import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MatPaginator, MAT_DIALOG_DATA, PageEvent } from '@angular/material';
import { Router } from '@angular/router';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import swal from 'sweetalert2';
import { Comissao } from '../models/comissao';
import { Filtro } from '../models/filtro';
import { CarregandoService } from '../services/carregando.service';
import { ComissaoService } from '../services/comissao.service';
import { GlobalService } from '../services/global.service';
import { NotificacaoService } from '../services/notificacao.service';
import { UtilitarioService } from '../services/utilitario.service';
import { CadastrarComissaoComponent } from './cadastrar-comissao/cadastrar-comissao.component';
import { PaginatorService } from '../services/paginator.service';

declare const $: any;

@Component({
  selector: 'app-comissao',
  templateUrl: './comissao.component.html',
  styleUrls: ['./comissao.component.scss']
})
export class ComissaoComponent implements OnInit, OnDestroy {

  // variáveis
  comissoesFiltrados: Comissao[] = [];
  carregando = true;
  campoOrdenacao = 'descricao';
  ordenarDesc = false;
  editavel = true;
  paginacao;
  listaDeItensPorPagina;
  itensPorPagina;
  filtroNome: Filtro = { Propriedade: 'nome', Valor: '' };
  filtros: Filtro[] = [this.filtroNome];
  public config: PerfectScrollbarConfigInterface = {};

  @ViewChild('paginator', { static: false }) paginator: MatPaginator;

  constructor(private comissaoService: ComissaoService, private utilitarioService: UtilitarioService,
    private router: Router, private globalService: GlobalService, private paginatorService: PaginatorService,
    private carregandoService: CarregandoService, private notificacaoService: NotificacaoService,
    public dialogRef: MatDialogRef<ComissaoComponent>, @Inject(MAT_DIALOG_DATA) public data: any, public dialog: MatDialog) { }

  ngOnInit() {
    const pagination = this.paginatorService.consultarPaginacao();

    this.paginacao = pagination.paginacao;
    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;

    this.buscarComissoes();
  }

  ordena(campo) {
    if (campo) {
      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;

      this.mudaDePagina({ length: this.paginator.length, pageIndex: this.paginator.pageIndex, pageSize: this.paginator.pageSize });
    }

    return false;
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (typeof a === 'string') {
      a = a.toLowerCase();
    }

    if (typeof b === 'string') {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  filtra() {
    this.buscarComissoes();
    this.paginator.firstPage();
  }

  buscarComissoes() {
    this.carregandoService.mostra('buscaComissoes');
    this.carregando = true;

    this.comissaoService.consultarComissoesComPaginacao(this.filtroNome.Valor, this.paginacao.paginaAtual, this.itensPorPagina,
      this.campoOrdenacao, this.ordenarDesc ? 'desc' : 'asc').subscribe(dados => {
        this.comissoesFiltrados = dados.itens;

        if (this.itensPorPagina > this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]) {
          this.itensPorPagina = 10;
        }

        this.paginacao.total = dados.total;

        this.carregando = false;
        this.carregandoService.esconde('buscaComissoes');
      }, (erro) => {
        this.carregandoService.esconde('buscaComissoes');
        this.notificacaoService.erro(erro);
      });


  }

  novoComissao() {
    const largura = Number(($('body').width()));
    const dialogRef = this.dialog.open(CadastrarComissaoComponent, {
      width: (($('body').width()).toString() + 'px'),
      data: { comissao: new Comissao() },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.buscarComissoes();
      }
    });
  }

  editarComissao(comissao: Comissao) {
    const largura = Number(($('body').width()));
    const comissaoParaEditar = new Comissao();
    Object.assign(comissaoParaEditar, comissao);

    const dialogRef = this.dialog.open(CadastrarComissaoComponent, {
      width: (($('body').width()).toString() + 'px'),
      data: { comissao: comissaoParaEditar },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.buscarComissoes();
      }
    });
  }

  excluirComissao(comissao: Comissao) {
    swal({
      title: 'Atenção!!',
      text: 'Deseja realmente excluir a Comissão?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.carregandoService.mostra('excluiComissao');
        this.comissaoService.excluir(comissao.id).subscribe(resp => {

          this.notificacaoService.sucesso('Comissão excluída com sucesso!!!');
          this.carregandoService.esconde('excluiComissao');
          this.filtra();
        }, (erro) => {
          this.carregandoService.esconde('excluiComissao');
          this.notificacaoService.erro(erro);
        });
      }
    });
  }

  mudaDePagina(pageEvent: PageEvent) {
    if (this.itensPorPagina !== pageEvent.pageSize)
      this.paginatorService.salvaPaginacao(pageEvent.pageSize);

    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarComissoes();
  }

  ngOnDestroy(): void { }

  fechar() {
    this.dialogRef.close();
  }
}